import { responseError } from '@/utils/errors';
import { removeItemByCode, selectableResult } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import initialState, {
  findWorkflow,
  findWorkflows,
  showWorkflowState,
  showWorkflowErrorState,
  workflowCompare,
  fetchWorkflowState,
} from './state';
import actions from '../constants';

const closeWorkflow = withDraft((draft, action) => {
  const item = findWorkflow(draft, action);
  if (item) {
    draft.workflows[action.category].results = removeItemByCode(draft.workflows[action.category].results, item);
  }
});

const closeWorkflows = withDraft((draft, { category }) => {
  draft.workflows[category] = initialState.workflows[category];
});

const fetchWorkflows = withDraft((draft, action) => {
  const item = findWorkflows(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showWorkflows = withDraft((draft, action) => {
  const item = findWorkflows(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.results.sort(workflowCompare).map(selectableResult);
});

const showWorkflowsError = withDraft((draft, action) => {
  const item = findWorkflows(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const showWorkflow = withDraft((draft, action) => showWorkflowState(draft, action));

export default {
  [actions.CLOSE_WORKFLOW]: closeWorkflow,
  [actions.CLOSE_WORKFLOWS]: closeWorkflows,
  [actions.FETCH_WORKFLOW]: fetchWorkflowState,
  [actions.FETCH_WORKFLOWS]: fetchWorkflows,
  [actions.REFRESH_WORKFLOWS]: fetchWorkflows,
  [actions.SHOW_WORKFLOW]: showWorkflow,
  [actions.SHOW_WORKFLOW_ERROR]: showWorkflowErrorState,
  [actions.SHOW_WORKFLOWS]: showWorkflows,
  [actions.SHOW_WORKFLOWS_ERROR]: showWorkflowsError,
};
